// extracted by mini-css-extract-plugin
module.exports = {"container":"_6444e049b8--container--FGPNc","marquee":"_6444e049b8--marquee--GbIzU","text":"_6444e049b8--text--iI6Ce"};